export const handleChangePriceInRobotintModal = (priceElement: HTMLElement[]) => {
  priceElement[0].textContent = 'от 20₽/л';
};
